<template>
  <div>
    <div class="filters-grid">
      <div class="filter-item">
          <AppInput v-model="filtersForm.search" placeholder="Buscar..."></AppInput>
      </div>

      <!-- Grupo: Control de Gestión / Nivel de Cumplimiento -->
      <div class="filter-item d-flex">
        <AppButton
          @click="changeMode('control-gestion')"
          :outline="currentMode !== 'control-gestion'"
          style="border-radius: 5px 0px 0px 5px;"
        >Control de Gestión</AppButton>
        <AppButton
          @click="changeMode('nivel-cumplimiento')"
          :outline="currentMode !== 'nivel-cumplimiento'"
          style="border-radius: 0px 5px 5px 0px;"
        >Nivel de Cumplimiento</AppButton>
      </div>

      <!-- Grupo: Por fecha / Por rango -->
      <div class="filter-item d-flex">
        <AppButton
          @click="toggleDateRange('date')" 
          :outline="isDateRange"
          style="border-radius: 5px 0px 0px 5px;"
        >Por fecha</AppButton>
        
        <AppButton
          @click="toggleDateRange('range')" 
          :outline="!isDateRange"
          style="border-radius: 0px 5px 5px 0px;"
        >Por rango</AppButton>
      </div>

      <div class="filter-item" v-if="!isDateRange">
          <AppInput type="date" v-model="filtersForm.date" placeholder="Seleccionar fecha"></AppInput>
      </div>
      <div class="filter-item" v-if="isDateRange">
          <AppInput type="date" v-model="filtersForm.startDate" placeholder="Desde"></AppInput>
      </div>
      <div class="filter-item" v-if="isDateRange">
          <AppInput type="date" v-model="filtersForm.endDate" placeholder="Hasta"></AppInput>
      </div>

      <!-- Grupo: Envíos / Retiros -->
      <div class="filter-item d-flex">
        <AppButton
          @click="setPickupFilter(null)"
          :outline="filtersForm.isPickupRequest !== null"
          style="border-radius: 5px 0px 0px 5px;"
        >Todos</AppButton>
        <AppButton
          @click="setPickupFilter(false)"
          :outline="filtersForm.isPickupRequest !== false"
          style="border-radius: 0px 0px 0px 0px;"
        >Envíos</AppButton>
        <AppButton
          @click="setPickupFilter(true)"
          :outline="filtersForm.isPickupRequest !== true"
          style="border-radius: 0px 5px 5px 0px;"
        >Retiros</AppButton>
      </div>

      <div class="filter-item">
        <AppButton variant="primary" @click="applyFilters">Filtrar</AppButton>
      </div>
    </div>
  </div>
</template>

<script>
import AppInput from '../UI/AppInput.vue'
import AppButton from '../UI/AppButton.vue'
import AppField from '../UI/AppField.vue'

export default {
  name: 'ManagementControlFilters',
  components: {
    AppInput,
    AppButton,
    AppField
  },
  props: {
    currentMode: {
      type: String,
      default: 'control-gestion'
    }
  },
  data() {
    const today = new Date().toISOString().split('T')[0]
    return {
      isDateRange: false,
      filtersForm: {
        search: '',
        date: today,
        startDate: '',
        endDate: '',
        isPickupRequest: null
      }
    }
  },
  methods: {
    changeMode(mode) {
      this.$emit('update:currentMode', mode)
    },
    applyFilters() {
      this.$emit('filter', { ...this.filters })
    },
    clearFilters() {
      const today = new Date().toISOString().split('T')[0]
      this.filtersForm = {
        search: '',
        date: today,
        startDate: '',
        endDate: '',
        isPickupRequest: null
      }
      this.applyFilters()
    },
    toggleDateRange(type) {
      if(type === 'date') {
        this.isDateRange = false
      } else {
        this.isDateRange = true
      }
    },
    setPickupFilter(value) {
      this.filtersForm.isPickupRequest = value
    }
  },
  computed: {
    filters() {
      const { date, startDate, endDate, isPickupRequest, ...rest } = this.filtersForm
      const filters = { ...rest }
      if(this.isDateRange) {
        filters.startDate = startDate
        filters.endDate = endDate
      } else {
        filters.date = date
      }
      if (isPickupRequest !== null) {
        filters.isPickupRequest = isPickupRequest
      }
      return filters
    }
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler() {
        this.$emit('value', { ...this.filters })
      }
    }
  },
  mounted() {
    this.applyFilters()
  }
}
</script>

<style scoped>
.filters-container {
  background-color: #fff;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 0.25rem;
  padding: 1.25rem;
  margin-top: 1.5rem;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(150px, max-content)
  );
  gap: 1rem;
  margin-bottom: 1rem;
}
</style>
